import React from "react";
import Weather from "./components/Weather";

const App = () => {
    return(
        <Weather/>
    )
}

export default App;